import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { IBuildTypeDto } from '@classictechsolutions/hubapi-transpiled-enums';
import {
    getLotMigratorFormErrorMessage,
    hasLotMigratorFormError
} from '../lot-migrator-form-errors';

@Component({
    selector: 'cb-lot-migrator-lot-build-section',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule
    ],
    templateUrl: './lot-migrator-lot-build-section.component.html',
    styleUrls: ['./lot-migrator-shared-section.styles.scss']
})
export class LotMigratorLotBuildSectionComponent {
    @Input({ required: true }) public lotForm!: FormGroup;
    @Input() public buildTypeOptions: IBuildTypeDto[] = [];
    @Input() public contractTypes: { id: number; label: string }[] = [];
    @Input() public lotTypes: { id: number; label: string }[] = [];
    @Input() public showAreas = false;
    @Input() public showBuildTypeLink = false;

    public hasError(controlName: string): boolean {
        return hasLotMigratorFormError(this.lotForm, controlName);
    }

    public getErrorMessage(controlName: string, label: string): string {
        return getLotMigratorFormErrorMessage(this.lotForm, controlName, label);
    }
}
